import { type ComponentProps, type FC } from 'react'

import { type RatingOwnerState } from 'base-ui'

export const ProductSearchRefinementRatingInputRatingIconContainer: FC<
  ComponentProps<'span'> & { ownerState: RatingOwnerState; value: number }
> = ({ ownerState, value, ...rest }) => (
  <span
    data-qa-id={
      value <= ownerState.value
        ? `form-star-rating-filled-${value - 1}`
        : `form-star-rating-empty-${value - 1}`
    }
    {...rest}
  />
)
